var IpcDataModel = require("./index.js");
var IpcNameHelper = require("./ipcNameHelper.js");
var PthComponentAttribute = require('./pth/pthComponentAttribute.js');
var UnitConversions = require("cio-config").UnitConversions;
var unit = ' mm';

function convertToMM(value) {
    var targetUnit = 'millimeter';
    var dataUnit = 'um';
    return UnitConversions.convert(dataUnit, targetUnit, value).toFixed(2);
}

function convertToInch(value) {
    var targetUnit = 'in';
    var dataUnit = 'um';
    return UnitConversions.convert(dataUnit, targetUnit, value).toFixed(2);
}

var IpcDescriptionHelper = {};

IpcDescriptionHelper.getHeaderPinCountInfo = function(data, forDescription) {
    var description = '';
    var totalPin = data.verticalPadCount() * data.horizontalPadCount();
    var pinCountRowColumnSize = data.verticalPadCount() + "X" + data.horizontalPadCount();

    if(data.verticalPadCount() === 1) {
        description = ((forDescription) ? 'Single-row (' + pinCountRowColumnSize + '), ' : 'Single-row, ');
    } else if(data.verticalPadCount() === 2) {
        description = ((forDescription) ? 'Double-row (' + pinCountRowColumnSize + '), ' : 'Double-row, ');
    } else if(data.verticalPadCount() === 3) {
        description = ((forDescription) ? 'Three-row (' + pinCountRowColumnSize + '), ' : 'Three-row, ');
    } else if(data.verticalPadCount() === 4) {
        description = ((forDescription) ? 'Four-row (' + pinCountRowColumnSize + '), ' : 'Four-row, ');
    } else {
        description = pinCountRowColumnSize + ', ';
    }

    return description + totalPin;
};

IpcDescriptionHelper.getHeaderPitchInfo = function(data) {
    var description = "";

    if(data.verticalPadCount() !== data.horizontalPadCount()) {
        if(data.horizontalPadCount() > 1 && data.verticalPadCount() > 1) {
            description += convertToMM(data.verticalPinPitch()) + unit + " (" + convertToInch(data.verticalPinPitch()) + " in)" + " row pitch, ";
            description += convertToMM(data.horizontalPinPitch()) + unit + " (" + convertToInch(data.horizontalPinPitch()) + " in)" + " col pitch, ";
        } else if(data.verticalPadCount() > 1) {
            description += convertToMM(data.verticalPinPitch()) + unit + " (" + convertToInch(data.verticalPinPitch()) + " in)" + " row pitch, ";
        } else if(data.horizontalPadCount() > 1) {
            description += convertToMM(data.horizontalPinPitch()) + unit + " (" + convertToInch(data.horizontalPinPitch()) + " in)" + " col pitch, ";
        }
    } else {
        if(data.horizontalPadCount() != 1) {
            description += convertToMM(data.verticalPinPitch()) + unit + " (" + convertToInch(data.verticalPinPitch()) + " in)" + " pitch, ";
        }
    }

    return description;
};

IpcDescriptionHelper.getPinNumberingPatternForHeaderPackages = function(data) {
    var pattern = data.pinNumberSequencePattern();
    var PinNumberSequencePattern = PthComponentAttribute.type.HEADER.pinNumberSequencePattern;

    switch(pattern) {
        case PinNumberSequencePattern["ZZBT"].key:
            return PinNumberSequencePattern["ZZBT"].description;
        break;

        case PinNumberSequencePattern["LRCCW"].key:
            return PinNumberSequencePattern["LRCCW"].description;
        break;

        case PinNumberSequencePattern["LRCW"].key:
            return PinNumberSequencePattern["LRCW"].description;
        break;
    }
};

//aligned with body length and width dims
IpcDescriptionHelper.getThermalPadDescription = function(data) {
    var length = convertToMM(data.thermalPadLength());
    var width = convertToMM(data.thermalPadWidth());
    return width + " X " + length;
};

//all dimentions mentioned in description are in mm
IpcDescriptionHelper.getReadableDescriptionFromIPCData = function(data) {
    var description = "";
    var packageName = "";

    if(data.constructor !== IpcDataModel.MelfData && data.constructor !== IpcDataModel.AxialData && data.constructor !== IpcDataModel.RadialRoundData && data.constructor !== IpcDataModel.SonData) {
        packageName = IpcNameHelper.getStandardPackageName(data) + " package";
    } else {
        packageName = IpcNameHelper.getStandardPackageName(data);
    }

    switch(data.constructor) {
        case IpcDataModel.SoicSopData:
        case IpcDataModel.SotflData:
        case IpcDataModel.CfpData:
        case IpcDataModel.Sot23Data:
        case IpcDataModel.Sot223Data:
        case IpcDataModel.Sot143Data:
        case IpcDataModel.ToDpakData:
        case IpcDataModel.SojData:
            //for DPAK package with middle lead trimmed pin count must be decremented by one
            var pinCount = (data.constructor === IpcDataModel.ToDpakData && data.hasTruncatedPin()) ? data.horizontalPadCount() - 1 : data.horizontalPadCount();

            description += pinCount + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " span";
            description += this.getBodyDescription(data, false) + unit;
            if(data.hasThermalPad && data.hasThermalPad()) description += " and thermal pad size " + this.getThermalPadDescription(data) + unit;
        break;

        case IpcDataModel.QfpData:
        case IpcDataModel.CqfpData:
            description += (2 * data.horizontalPadCount() + 2 * data.verticalPadCount()) + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.verticalLeadToLeadSpanMax() / 2 + data.verticalLeadToLeadSpanMin() / 2) + unit + " lead span1";
            description += " X " + convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " lead span2";
            description += this.getBodyDescription(data, false) + unit;
            if(data.hasThermalPad()) description += " and thermal pad size " + this.getThermalPadDescription(data) + unit;
        break;

        case IpcDataModel.PlccData:
            description += (2 * data.horizontalPadCount() + 2 * data.verticalPadCount()) + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " lead span1";
            description += " X " + convertToMM(data.verticalLeadToLeadSpanMax() / 2 + data.verticalLeadToLeadSpanMin() / 2) + unit + " lead span2";
            description += this.getBodyDescription(data, true) + unit;
        break;

        case IpcDataModel.SodData:
        case IpcDataModel.SodflData:
            description += packageName;
            description += " with " + convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " span";
            description += this.getBodyDescription(data, true) + unit;
        break;

        case IpcDataModel.OscillatorJLeadData:
        case IpcDataModel.OscillatorLBendData:
        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
        case IpcDataModel.ChipArrayTwoSideConvexData:
        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            description += data.horizontalPadCount() + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch";
            description += this.getBodyDescription(data, false) + unit;
        break;

        case IpcDataModel.ChipData:
        case IpcDataModel.ChipLedData:
        case IpcDataModel.MoldedBodyData:
        case IpcDataModel.CrystalData:
        case IpcDataModel.OscillatorCornerConcaveData:
            description += packageName;
            description += this.getBodyDescription(data, true) + unit;
        break;

        case IpcDataModel.MelfData:
            description += packageName;
            description += " " + IpcNameHelper.getStandardPackageFamilyNameForDescription(data) + " package";
            description += " with " + convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + unit + " length";
            description += " and " + convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2) + unit + " diameter";
        break;

        case IpcDataModel.QfnData:
            description += (2 * data.horizontalPadCount() + 2 * data.verticalPadCount()) + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch";
            description += this.getBodyDescription(data, false) + unit;
            if(data.hasThermalPad()) description += " and thermal pad size " + this.getThermalPadDescription(data) + unit;
        break;

        case IpcDataModel.Dfn2Data:
        case IpcDataModel.Dfn3Data:
        case IpcDataModel.Dfn4Data:
            description += packageName;
            description += this.getBodyDescription(data, true) + unit;
        break;

        case IpcDataModel.AluminumElectrolyticData:
            description += packageName;
            description += " with body size " + convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + " X " + convertToMM(data.bodyHeightMax()) + unit;
        break;

        case IpcDataModel.BgaData:
            description += (data.horizontalPadCount() * data.verticalPadCount()) + "-pin ";
            description += (data.terminalType() === IpcDataModel.ComponentAttribute.bgaTerminalType["Collapsing_Ball"]) ? "collapsing " : "non-collapsing ";
            description += packageName;
            description += " with " + convertToMM(data.horizontalPinPitch()) + unit + " col pitch";
            description += " and " +  convertToMM(data.verticalPinPitch()) + unit + " row pitch";
            description += this.getBodyDescription(data, false) + unit;
        break;

        case IpcDataModel.AxialData:
            description += packageName;
            description += " " + IpcNameHelper.getStandardPackageFamilyNameForDescription(data) + " package";
            description += " with " + convertToMM(data.getPinPitch()) + unit + " pitch (lead spacing), ";
            description += convertToMM(data.terminalWidth()) + unit + " lead diameter, ";
            description += convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + unit + " body length";
            description += " and " + convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2) + unit + " body diameter";
        break;

        case IpcDataModel.DipData:
            description += data.horizontalPadCount() + "-pin ";
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " (" + convertToInch(data.verticalPinPitch()) + " in) " + "pitch, ";
            description += convertToMM(data.leadSpan()) + unit + " (" + convertToInch(data.leadSpan()) + " in) " + "span";
            description += this.getBodyDescription(data, false) + unit;
        break;

        //Double-row (2X20), 40-pin Pin Header (Male) Straight/Right Angle package with 2.54 mm (0.1 inch) pitch, 0.6 mm lead width, 1 mm tail length and 1 mm mating length with overall/body size 5.08 X 2.54 X 4 mm, pin pattern
        //Single-row (1X40), 40-pin Pin Header (Male) Straight/Right Angle package with 2.54 mm (0.1 inch) pitch, 0.6 mm lead width, 1 mm tail length and 1 mm mating length with overall/body size 5.08 X 2.54 X 4 mm, pin pattern
        //3x4, 12-pin Pin Header (Male) Straight/Right Angle package with 2.54 mm (0.1 inch) pitch, 0.6 mm lead width, 1 mm tail length and 1 mm mating length with overall/body size 5.08 X 2.54 X 4 mm, pin pattern
        //Double-row (2X4), 8-pin Receptacle Header (Female) Right Angle package with 2.54 mm (0.10 in) pitch, 0.64 mm lead width, 3 mm tail length with body size 10.16 mm X 7.36 mm X 5.56 mm, pin pattern - clockwise from top left
        case IpcDataModel.HeaderStraightData:
        case IpcDataModel.HeaderRightAngleData:
        case IpcDataModel.HeaderStraightSocketData:
        case IpcDataModel.HeaderRightAngleSocketData:
            description += this.getHeaderPinCountInfo(data, true) + "-pin ";
            description += packageName + " with ";
            description += this.getHeaderPitchInfo(data);
            description += convertToMM(data.terminalWidth()) + unit + " lead width, ";

            if(data.constructor == IpcDataModel.HeaderStraightData || data.constructor == IpcDataModel.HeaderStraightSocketData) {
                description += convertToMM(data.terminalTailLength()) + unit + " tail length";
            } else {
                description += convertToMM(data.verticalTerminalTailLength()) + unit + " tail length";
            }

            if(data.constructor == IpcDataModel.HeaderStraightData || data.constructor == IpcDataModel.HeaderRightAngleData) {
                description += " and " + convertToMM(data.terminalPostLength()) + unit + " mating length";
            } else if(data.constructor == IpcDataModel.HeaderStraightSocketData) {
                description += " and " + convertToMM(data.bodyHeightMax()) + unit + " insulator length";
            } else if(data.constructor == IpcDataModel.HeaderRightAngleSocketData) {
                description += " and " + convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2) + unit + " insulator length";
            }

            if(data.constructor == IpcDataModel.HeaderStraightData || data.constructor == IpcDataModel.HeaderStraightSocketData) {
                description += " with overall size " + convertToMM(data.bodyLengthMin() / 2 + data.bodyLengthMax() / 2);
            } else {
                description += " with body size " + convertToMM(data.bodyLengthMin() / 2 + data.bodyLengthMax() / 2);
            }

            description += " X " + convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2);
            description += " X " + convertToMM(IpcNameHelper.getComponentHeightForHeaderData(data)) + unit;

            if(data.horizontalPadCount() * data.verticalPadCount() != 1) {
                description += ", pin pattern - " + this.getPinNumberingPatternForHeaderPackages(data).toLowerCase();
            }
        break;

        case IpcDataModel.SonData:
            description += data.horizontalPadCount() + "-pin ";
            description += packageName + " (DFN) package";
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch";
            description += this.getBodyDescription(data, false) + unit;
            if(data.hasThermalPad()) description += " and thermal pad size " + this.getThermalPadDescription(data) + unit;
        break;

        case IpcDataModel.RadialRoundData:
        case IpcDataModel.RadialLedRoundData:
            description += packageName;
            if(data.constructor == IpcDataModel.RadialRoundData) {
                description += " " + IpcNameHelper.getStandardPackageFamilyNameForDescription(data) + " package";
            }
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch (lead spacing), ";

            if(data.constructor == IpcDataModel.RadialLedRoundData && data.leadShape() === PthComponentAttribute.leadShapes["Rectangle"]) {
                description += convertToMM(data.terminalWidth()) + unit + " lead width, " + convertToMM(data.terminalThickness()) + unit + " lead thickness, ";
            } else {
                description += convertToMM(data.terminalWidth()) + unit + " lead diameter, ";
            }

            description += convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2) + unit + " body diameter";
            description += " and " + convertToMM(data.bodyHeightMax()) + unit + " body height";
        break;

        case IpcDataModel.CrystalHC49Data:
            description += packageName;
            description += " with " + convertToMM(data.verticalPinPitch()) + unit + " pitch (lead spacing) and ";
            description += convertToMM(data.terminalWidth()) + unit + " lead diameter";
            description += this.getBodyDescription(data, true) + unit;
        break;

        //Snap Lock (lock-in) package with 3.18 mm hole diameter, 4.60 mm body diameter and 8.13 mm body height for 1.60 mm board/panel thickness
        case IpcDataModel.SnapLockData:
            description += packageName;
            description += " with " + convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyWidthMax()) + unit + " body diameter and ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height for ";
            description += convertToMM(data.boardThickness()) + unit + " board/panel thickness";
            
        break;

        case IpcDataModel.FemaleStandoffSpacerData:
            description += "Female " + (data.bodyShape()) + " " +packageName;
            description += " with " + convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height, "; 
            description += convertToMM(data.bodyWidthMax()) + unit + " body width";
            if (data.hasThread()){
                description += " with ";
                if (data.hasPartialThread()){
                    description += "partial thread " ;
                }
                else {
                    description += "thread " ;
                }
                description += "size " + (data.threadDesignation()) ; 
                description += ", " + convertToMM(data.threadDepth()) + unit + " thread depth";
            }

            if (data.withPad()){
                if (data.plated()) {
                    description += ", plated " ;
                }
                else {
                    description += ", non plated " ;
                }
                description += "with " + convertToMM(data.padDiameter()) + unit + " mounting pad" ;
                if (data.withVia()){
                    if (data.viaCount() != 0 && data.viaDiameter() != 0){
                        description += " and " + convertToMM(data.viaDiameter()) + unit  + " via." ;
                    }
                    else{
                        description += ".";
                    }
                }
                else{
                    description += ".";
                }
            }
            else {
                description += ".";
            }
        break;

        case IpcDataModel.MaleFemaleStandoffSpacerData:
            description += "Male-Female " + (data.bodyShape()) + " " + packageName;
            description += " with " + convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height, ";
            description += convertToMM(data.bodyWidthMax()) + unit + " body width " ;
            description += "with post thread size " + (data.postThreadDesignation()) + ", " ;
            description += convertToMM(data.postLength()) + unit + " length and ";
            description +=  "inner thread size "+ (data.innerThreadDesignation()) + ", ";
            description += convertToMM(data.innerThreadDepth()) + unit + " depth";
  
            if (data.withPad()){
                if (data.plated()) {
                    description += ", plated ";
                }
                else {
                    description += ", non plated ";
                }
                description += "with " + convertToMM(data.padDiameter()) + unit + " mounting pad" ;
                if (data.withVia()){
                    if (data.viaCount() != 0 && data.viaDiameter() != 0){
                        description += " and " + convertToMM(data.viaDiameter()) + unit  + " via." ;
                    }
                    else{
                        description += ".";
                    }
                }
                else{
                    description += ".";
                }
            }
            else {
                description += ".";
            }
        break;
    }

    return description;
};

IpcDescriptionHelper.getShortDescriptionFromIPCData = function(data) {
    var description = "";
    var packageName = IpcNameHelper.getStandardPackageName(data);

    switch(data.constructor) {
        case IpcDataModel.SoicSopData:
        case IpcDataModel.SotflData:
        case IpcDataModel.CfpData:
        case IpcDataModel.Sot23Data:
        case IpcDataModel.Sot223Data:
        case IpcDataModel.Sot143Data:
        case IpcDataModel.ToDpakData:
        case IpcDataModel.SojData:
            //for DPAK package with middle lead trimmed pin count must be decremented by one
            var pinCount = (data.constructor === IpcDataModel.ToDpakData && data.hasTruncatedPin()) ? data.horizontalPadCount() - 1 : data.horizontalPadCount();

            description += pinCount + "-";
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " span, ";
            description += this.getBodyShortDescription(data, false) + unit + " body";
            if(data.hasThermalPad && data.hasThermalPad()) description += ", " + this.getThermalPadDescription(data) + unit + " thermal pad";
        break;

        case IpcDataModel.QfpData:
        case IpcDataModel.CqfpData:
        case IpcDataModel.PlccData:
            description += (2 * data.horizontalPadCount() + 2 * data.verticalPadCount()) + "-";
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";

            var hSpan = convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2);
            var vSpan = convertToMM(data.verticalLeadToLeadSpanMax() / 2 + data.verticalLeadToLeadSpanMin() / 2);

            if(hSpan === vSpan) {
                description += hSpan + unit + " span, ";
            } else {
                if(data.constructor == IpcDataModel.PlccData) {
                    description += hSpan + unit + " lead span1, ";
                    description += vSpan + unit + " lead span2, ";
                } else {
                    description += vSpan + unit + " lead span1, ";
                    description += hSpan + unit + " lead span2, ";
                }
            }

            if(data.constructor == IpcDataModel.PlccData) {
                description += this.getBodyShortDescription(data, true) + unit + " body";
            } else {
                description += this.getBodyShortDescription(data, false) + unit + " body";
                if(data.hasThermalPad()) description += ", " + this.getThermalPadDescription(data) + unit + " thermal pad";
            }
        break;

        case IpcDataModel.SodData:
        case IpcDataModel.SodflData:
            description += packageName + ", ";
            description += convertToMM(data.horizontalLeadToLeadSpanMax() / 2 + data.horizontalLeadToLeadSpanMin() / 2) + unit + " span, ";
            description += this.getBodyShortDescription(data, true) + unit + " body";
        break;

        case IpcDataModel.OscillatorJLeadData:
        case IpcDataModel.OscillatorLBendData:
        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
        case IpcDataModel.ChipArrayTwoSideConvexData:
        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            description += data.horizontalPadCount() + "-";
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += this.getBodyShortDescription(data, false) + unit + " body";
        break;

        case IpcDataModel.ChipData:
        case IpcDataModel.ChipLedData:
        case IpcDataModel.MoldedBodyData:
        case IpcDataModel.CrystalData:
        case IpcDataModel.OscillatorCornerConcaveData:
            description += packageName + ", ";
            description += this.getBodyShortDescription(data, true) + unit + " body";
        break;

        case IpcDataModel.MelfData:
            description += packageName + ", ";
            description += convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + unit + " length, ";
            description += convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2) + unit + " diameter";
        break;

        case IpcDataModel.QfnData:
            description += (2 * data.horizontalPadCount() + 2 * data.verticalPadCount()) + "-";
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += this.getBodyShortDescription(data, false) + unit + " body";
            if(data.hasThermalPad()) description += ", " + this.getThermalPadDescription(data) + unit + " thermal pad";
        break;

        case IpcDataModel.Dfn2Data:
        case IpcDataModel.Dfn3Data:
        case IpcDataModel.Dfn4Data:
            description += packageName + ", ";
            description += this.getBodyShortDescription(data, true) + unit + " body";
        break;

        case IpcDataModel.AluminumElectrolyticData:
            description += packageName + ", ";
            description += convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + " X " + convertToMM(data.bodyHeightMax()) + unit + " body";
        break;

        case IpcDataModel.BgaData:
            description += (data.horizontalPadCount() * data.verticalPadCount()) + "-";
            description += packageName + ", ";
            description += ((data.terminalType() === IpcDataModel.ComponentAttribute.bgaTerminalType["Collapsing_Ball"]) ? "collapsing" : "non-collapsing") + ", ";

            if(data.horizontalPinPitch() === data.verticalPinPitch()) {
                description += convertToMM(data.horizontalPinPitch()) + unit + " pitch, ";
            } else {
                description += convertToMM(data.horizontalPinPitch()) + unit + " col pitch, ";
                description += convertToMM(data.verticalPinPitch()) + unit + " row pitch, ";
            }

            description += this.getBodyShortDescription(data, false) + unit + " body";
        break;

        case IpcDataModel.AxialData:
            description += packageName;
            description += " " + IpcNameHelper.getStandardPackageFamilyNameForDescription(data) + ", ";
            description += convertToMM(data.getPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2) + unit + " body length, ";
            description += convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2) + unit + " body diameter";
        break;

        case IpcDataModel.DipData:
            description += data.horizontalPadCount() + "-";
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " (" + convertToInch(data.verticalPinPitch()) + " in) " + "pitch, ";
            description += convertToMM(data.leadSpan()) + unit + " (" + convertToInch(data.leadSpan()) + " in) " + "span, ";
            description += this.getBodyShortDescription(data, false) + unit + " body";
        break;

        //Double-row (2X20), 40-pin Pin Header (Male) Straight/Right Angle package, 2.54 mm (0.1 inch) pitch, 1 mm mating length, 5.08 X 2.54 X 4 mm body
        //Single-row (1X40), 40-pin Pin Header (Male) Straight/Right Angle package, 2.54 mm (0.1 inch) pitch, 1 mm mating length, 5.08 X 2.54 X 4 mm body
        //3x40-pin Pin Header (Male) Straight/Right Angle package, 2.54 mm (0.1 inch) pitch, 1 mm mating length, 5.08 X 2.54 X 4 mm body
        //Double-row, 8-pin Receptacle Header (Female) Right Angle, 2.54 mm (0.10 in) pitch, 10.16 mm X 7.36 mm X 5.56 mm body
        case IpcDataModel.HeaderStraightData:
        case IpcDataModel.HeaderRightAngleData:
        case IpcDataModel.HeaderStraightSocketData:
        case IpcDataModel.HeaderRightAngleSocketData:
            description += this.getHeaderPinCountInfo(data) + "-pin ";
            description += packageName + ", ";
            description += this.getHeaderPitchInfo(data);

            if(data.constructor == IpcDataModel.HeaderStraightData || data.constructor == IpcDataModel.HeaderRightAngleData) {
                description += convertToMM(data.terminalPostLength()) + unit + " mating length, ";
            } else if(data.constructor == IpcDataModel.HeaderStraightSocketData) {
                description += convertToMM(data.bodyHeightMax()) + unit + " insulator length, ";
            } else if(data.constructor == IpcDataModel.HeaderRightAngleSocketData) {
                description += convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2) + unit + " insulator length, ";
            }

            description += convertToMM(data.bodyLengthMin() / 2 + data.bodyLengthMax() / 2);
            description += " X " + convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2);
            description += " X " + convertToMM(IpcNameHelper.getComponentHeightForHeaderData(data)) + unit;
            description += " body";
        break;

        case IpcDataModel.SonData:
            description += data.horizontalPadCount() + "-";
            description += packageName + " (DFN), ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += this.getBodyShortDescription(data, false) + unit + " body";
            if(data.hasThermalPad()) description += ", " + this.getThermalPadDescription(data) + unit + " thermal pad";
        break;

        case IpcDataModel.RadialRoundData:
        case IpcDataModel.RadialLedRoundData:
            description += packageName;
            if(data.constructor == IpcDataModel.RadialRoundData) {
                description += " " + IpcNameHelper.getStandardPackageFamilyNameForDescription(data);
            }
            description += ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += convertToMM(data.bodyWidthMin() / 2 + data.bodyWidthMax() / 2) + unit + " body diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height";
        break;

        case IpcDataModel.CrystalHC49Data:
            description += packageName + ", ";
            description += convertToMM(data.verticalPinPitch()) + unit + " pitch, ";
            description += this.getBodyShortDescription(data, true) + unit + " body";
        break;

        case IpcDataModel.SnapLockData:
            description += packageName + ", ";
            description += convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height for ";
            description += convertToMM(data.boardThickness()) + unit + " board/panel thickness";
        break;

        case IpcDataModel.FemaleStandoffSpacerData:
            description += "Female " + (data.bodyShape()) + " " +packageName ;
            description += " with " + convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height, "; 
            description += convertToMM(data.bodyWidthMax()) + unit + " body width";
            if (data.hasThread()){
                description += " with";
                if (data.hasPartialThread()){
                    description += " partial thread " ;
                }
                else {
                    description += " thread " ;
                }
                description += "size " + (data.threadDesignation()) ; 
            }
    
            if (data.withPad()){
                if (data.plated()) {
                    description += ", plated" ;
                }
                else {
                    description += ", non plated" ;
                }
                description +=  " mounting pad" ;
                if (data.withVia()){
                    if(data.viaCount() != 0 && data.viaDiameter()!= 0){
                        description += " and via." ;
                    }
                    else{
                    description += ".";
                    }
                }
                else{
                    description += ".";
                }
            }
            else{
                description += ".";
            }      
        break;

        case IpcDataModel.MaleFemaleStandoffSpacerData:
            description += "Male-Female " + (data.bodyShape()) + " " + packageName;
            description += " with " + convertToMM(data.holeDiameter()) + unit + " hole diameter, ";
            description += convertToMM(data.bodyHeightMax()) + unit + " body height, ";
            description += convertToMM(data.bodyWidthMax()) + unit + " body width " ;
            description += "with post thread size " + (data.postThreadDesignation())  ;
            description +=  " and inner thread size " + (data.innerThreadDesignation()) ;
            if (data.withPad()){
                if (data.plated()) {
                    description += ", plated" ;
                }
                else {
                    description += ", non plated" ;
                }
                description +=  " mounting pad" ;
                if (data.withVia()){
                    if(data.viaCount() != 0 && data.viaDiameter()!= 0){
                        description += " and via." ;
                    }
                    else{
                    description += ".";
                    }
                }
                else{
                    description += ".";
                    }

            }
            else{
                description += ".";
            }      
        break;
    }

    return description;
};

//rotated flag is true if package is generated along x direction (e.g., chip, sod, etc)
IpcDescriptionHelper.getBodyDescription = function(data, rotated) {
    var description = "";

    if(!rotated) { //aligned in y direction
        description += " with body size " + convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2)
                + " X " + convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2)
                + " X " + convertToMM(data.bodyHeightMax());
    } else {//aligned in x direction
        description += " with body size " + convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2)
                + " X " + convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2)
                + " X " + convertToMM(data.bodyHeightMax());
    }

    return description;
};

IpcDescriptionHelper.getBodyShortDescription = function(data, rotated) {
    var description = "";

    if(!rotated) { //aligned in y direction
        description += convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2)
                + " X " + convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2)
                + " X " + convertToMM(data.bodyHeightMax());
    } else {//aligned in x direction
        description += convertToMM(data.bodyWidthMax() / 2 + data.bodyWidthMin() / 2)
                + " X " + convertToMM(data.bodyLengthMax() / 2 + data.bodyLengthMin() / 2)
                + " X " + convertToMM(data.bodyHeightMax());
    }

    return description;
};

module.exports = IpcDescriptionHelper;
